import { api } from "@breakout/backend/convex/_generated/api"
import { convexQuery } from "@convex-dev/react-query"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"
import { WeekView } from "../components/home/WeekView"
import { WeekViewSkeleton } from "../components/home/WeekViewSkeleton"
import { PageContainer } from "../components/layout/PageContainer"
import { useDocumentTitle } from "../hooks/common/useDocumentTitle"

export const Route = createFileRoute("/past/$weekId")({
	component: WeekDetailsPage,
	params: {
		parse: params => {
			const weekId = params.weekId
			// Validate weekId is non-empty and alphanumeric (Convex IDs are alphanumeric)
			if (!weekId || !/^[\w-]+$/.test(weekId)) {
				throw new Error("Invalid week ID")
			}
			return { weekId }
		},
		stringify: params => ({ weekId: params.weekId }),
	},
})

function WeekDetailsPage() {
	const { weekId } = Route.useParams()

	// Same query as home page, but with specific weekId
	const { data, isLoading } = useQuery(convexQuery(api.public.home.getWeekViewData, { weekId }))

	// Document title shows week date when available
	useDocumentTitle(
		data?.week
			? `Week of ${new Date(data.week.openTimeSec * 1000).toLocaleDateString("en-US", { month: "short", day: "numeric" })}`
			: null,
	)

	if (isLoading) {
		return (
			<div className="bg-bg-primary text-text-primary">
				<PageContainer className="pt-5 pb-8 sm:pt-8">
					<WeekViewSkeleton />
				</PageContainer>
			</div>
		)
	}

	if (!data) {
		return (
			<div className="bg-bg-primary text-text-primary">
				<PageContainer className="py-12">
					<div className="rounded-2xl border border-border border-dashed bg-bg-card py-16 text-center shadow-sm">
						<p className="font-medium text-text-secondary">Week Not Found</p>
						<p className="mt-2 text-sm text-text-muted">Week {weekId} does not exist.</p>
						<Link
							className="mt-4 inline-block font-medium text-text-primary hover:underline"
							to="/weeks"
						>
							View all weeks
						</Link>
					</div>
				</PageContainer>
			</div>
		)
	}

	return (
		<div className="bg-bg-primary text-text-primary">
			<PageContainer className="pt-5 pb-8 sm:pt-8">
				<WeekView creators={data.creators} ffgMarket={data.ffgMarket} week={data.week} />
			</PageContainer>
		</div>
	)
}
